// extracted by mini-css-extract-plugin
export default {"marquee_wrapper":"marquee_marquee_wrapper__1ivjT","marquee":"marquee_marquee__BfAgG","track":"marquee_track__VHTnW","pair":"marquee_pair__2u9fz","word":"marquee_word__rK3ZT"};